import {useMemo} from 'react';
import {Navigate, Outlet, useLocation} from 'react-router';
import {useAuthState} from 'services/auth/hooks/useAuthState';
import {Layout} from '../components';
import {useCreateRedirect} from '../navigation';
import {TopBar} from '../widgets';
import './App.scss';

function App() {
  const {authState} = useAuthState();
  const themeColor = '#EAEADE'; // useBackgroundColor();
  const location = useLocation();

  const bodySx = useMemo(
    () => ({
      background: themeColor,
    }),
    [themeColor],
  );

  const redirect = useCreateRedirect();

  if (authState.status !== 'Authenticated') {
    return <Navigate to={`/login${redirect ?? ''}`} />;
  }

  return (
    <Layout height="100vh">
      <TopBar role="admin" />
      <Layout flex={1} sx={bodySx}>
        {/* Set location key to support reload, i.e. unmount/remount when navigating to same path&search (but with new key) */}
        <Outlet key={location.key} />
      </Layout>
    </Layout>
  );
}

export default App;
